import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ChangeDetectorRef
} from "@angular/core";
import { EditableTableComponent } from "../../../editable-table/editable-table.component";
import { EditableTableHeader } from "../../../../models/editable-table-header.interface";
import { CommonModule } from "@angular/common";
import tableHeaders from "../table-headers.json";
import { FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from "@angular/forms";
import { AutocompleteDropdownComponent } from "../../../autocomplete-dropdown/autocomplete-dropdown.component";
import { ToggleComponent } from "../../../common/toggle/toggle.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../../services/api.service";
import { finalize, forkJoin, from, map, Observable, of, startWith, tap } from "rxjs";
import { Container } from "../../../../models/container.interface";
import { DatePipe, NgClass, NgIf } from "@angular/common";
import { OperationService } from "../../../../services/operations.service";
import { ImportCargoItem } from "../../../../models/cargo-item.interface";
import { LoadingService } from "../../../../services/loading.service";
import { SelectComponent } from "../../../select/select.component";
import { ToasterService } from "../../../../services/toaster.service";
import { MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from "@angular/material/datepicker";
import { DatePickerComponent } from "../../../common/date-picker/date-picker.component";
import { AutocompleteDropdownComponentValidator } from "../../../../validators/autoCompleteValidator";
import { select } from "@ngrx/store";
import { HighlightPipe } from "../../../../pipes/highlight.pipe";
import { DeliveryMode } from "../../../../constants/operations-contsants";
import { MultiSelectComponent } from "../../../select/multi-select.component";
import { ExaminationType } from "../../../../constants/app-constants";
import { SharedModule } from "../../../../modules/shared/shared.module";
import { CustomerService } from "../../../../services/masters/customer-service";
import { PageCloseButtonComponent } from "../../../common/close-button/page-close-button.component";

@Component({
  selector: "app-manage-item-filing",
  standalone: true,
  imports: [
    EditableTableComponent,
    ReactiveFormsModule,
    AutocompleteDropdownComponent,
    ToggleComponent,
    NgClass,
    SelectComponent,
    CommonModule,
    MatFormField,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    DatePickerComponent,
    MultiSelectComponent,
    HighlightPipe,
    SharedModule,
    PageCloseButtonComponent
  ],
  templateUrl: "./manage-item-filing.component.html",
  styleUrls: ["./manage-item-filing.component.scss"]
})
export class ManageItemFilingComponent implements AfterViewInit {
  private sectionMap: Map<string, any> = new Map();
  tabs = {
    ALL_SECTION: "allSection",
    ITEM_DETAILS_SECTION: "itemDetailsSection",
    CONTAINER_DETAILS_SECTION: "containerDetailsSection"
  };
  tableHeaders: EditableTableHeader[] = [];
  tableData: Container[] = [];
  itemFilingForm!: FormGroup;
  itemFilingId: string = "";
  selectedTab: string = this.tabs.ALL_SECTION;
  editingEnabled: boolean = false;
  readOnlyMode: boolean = false;
  consigneeAddressList: any[] = [];
  notifyPartyAddressList: any[] = [];
  highSealCustomerAddressList: any[] = [];
  isHighSeaSaleCustomer: boolean = false;
  deLinkedContainerIds: Set<String> = new Set();
  deliveryModeOptions = Object.values(DeliveryMode).map(mode => ({ label: mode.label, value: mode.key }));
  examinationTypeOptions = Object.values(ExaminationType).map(type => ({ label: type.value, value: type.key }));
  //search bar config
  loading: boolean = false;
  showSuggestions: boolean = false;
  suggestions: any[] = [];
  searchTerm: string = "";
  searchBarSelectFields: String[] = ["id", "containerNo", "gateInDate"];
  searchBarDisplayColumns: any[] = [
    { key: "containerNo", header: "Container Number" }
  ];
  searchedAndSelectedRecord: any

  @ViewChild("allSection") allSection: ElementRef | undefined;
  @ViewChild("itemDetailsSection") itemDetailsSection: ElementRef | undefined;
  @ViewChild("containerDetailsSection", { read: ElementRef }) containerDetailsSection: ElementRef | undefined;
  @ViewChildren("formField") formFields!: QueryList<ElementRef>;


  constructor(private fb: FormBuilder,
              private router: Router,
              private route: ActivatedRoute,
              private api: ApiService,
              private commonApiService: ApiService,
              private operationService: OperationService,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private customerService: CustomerService,
              private cdRef: ChangeDetectorRef) {
    this.tableHeaders = tableHeaders;
    this.itemFilingForm = this.getItemFilingForm();
  }

  ngOnInit() {
    this.itemFilingId = this.route.snapshot.paramMap.get("item-filing-id") || "";

    if (this.itemFilingId === "") {
      console.log("Item Filing Id not found");
      this.readOnlyMode = false;
      this.editingEnabled = false;
      return;
    }

    if (this.route.snapshot.url[0].path === "edit") {
      this.editingEnabled = true;
      this.readOnlyMode = false;
    } else {
      this.editingEnabled = false;
      this.readOnlyMode = true;
      this.itemFilingForm.disable();
    }

    this.loadingService.show();
    this.operationService.getImportCargoById(this.itemFilingId, true, false).subscribe({
      next: (response: any) => {
        const data = response?.data;
        this.hydrateForm(data);

        this.tableData = this.resolveLookupFieldsInAssociatedContainersTable(data.associatedContainerList);
        console.log("This table data => ", this.tableData);
        this.loadingService.hide();
      },
      error: (error) => {
        console.error(error);
        this.loadingService.hide();
      }
    });
  }

  private resolveLookupFieldsInAssociatedContainersTable(associatedContainers: Container[]) {
    if (!associatedContainers?.length) return [];
    return associatedContainers.map((item: any) => {
      const transformedItem = { ...item }; // Copy the item
      this.tableHeaders
        .filter(header => header?.hasLookup) // Filter headers with lookup configuration
        .forEach((header) => {
          const bindLabel = header.fieldInfo?.lookupDetails?.responseBindLabel;
          const bindValue = header.fieldInfo?.lookupDetails?.responseBindValue;
          const fieldKey = header?.label; // The field to update in the item
          if (bindLabel && bindValue && fieldKey) {
            transformedItem[fieldKey] = {
              key: item[bindValue] || null,
              value: item[bindLabel] || null
            };
          }
        });
      return transformedItem;
    });
  }

  private hydrateForm(data: any) {
    if (data.isHighSeaSaleCustomer) {
      this.itemFilingForm.get("highSeaSaleCustomerId")?.addValidators(Validators.required);
      this.itemFilingForm.get("highSeaSaleCustomerAddressId")?.addValidators(Validators.required);
    }
    this.initialiseCustomerAddressList(data).subscribe(() => {
      this.itemFilingForm.patchValue({
        ...data,
        boeDate: data?.boeDate?.split("T")[0],
        igmDate: data?.igmDate?.split("T")[0],
        blDate: data?.blDate?.split("T")[0],
        accountHolderId: { key: data?.accountHolderId, value: data?.accountHolderName },
        vesselId: { key: data?.vesselId, value: data?.vesselName },
        chaId: { key: data?.chaId, value: data?.chaName },
        consigneeId: { key: data?.consigneeId, value: data?.consigneeName },
        notifyPartyId: { key: data?.notifyPartyId, value: data?.notifyPartyName },
        packageTypeId: { key: data?.packageTypeId, value: data?.packageTypeValue },
        commodityId: { key: data?.commodityId, value: data?.commodityValue },
        highSeaSaleCustomerId: { key: data?.highSeaSaleCustomerId, value: data?.highSeaSaleCustomerName },
        shippingLineId: { key: data?.shippingLineId, value: data?.shippingLineName },
        portOfLoading: { key: data?.portOfLoading, value: data?.portOfLoadingName }
      });
      this.onHighSealToggle(data.highSeaSaleCustomer);
      this.onSmtpToggle(data.smtpMovement);
    });

    if (this.editingEnabled) {
      //todo get customerAddress and populate consignee, notifyParty and high seal customer address list
    }
  }

  ngAfterViewInit() {
    if (this.allSection) this.sectionMap.set(this.tabs.ALL_SECTION, this.allSection.nativeElement);
    if (this.itemDetailsSection) this.sectionMap.set(this.tabs.ITEM_DETAILS_SECTION, this.itemDetailsSection.nativeElement);
    if (this.containerDetailsSection) this.sectionMap.set(this.tabs.CONTAINER_DETAILS_SECTION, this.containerDetailsSection.nativeElement);
  }

  scrollToSection(sectionId: string) {
    this.selectedTab = sectionId;
    const section = this.sectionMap.get(sectionId);
    const container = document.querySelector(".full_page_container");

    if (section && container) {
      const sectionTop = section.getBoundingClientRect().top - container.getBoundingClientRect().top;
      container.scrollTo({
        top: sectionTop + container.scrollTop,
        behavior: "smooth"
      });
    }
  }

  getItemFilingForm(): FormGroup {
    return this.fb.group({
      igmNo: ["", Validators.required],
      itemNo: ["", Validators.required],
      subItemNo: ["", Validators.required],
      igmDate: [null],
      blDate: [null],
      blNo: [""],
      hblDate: [null],
      hblNo: [""],
      vesselId: ["", AutocompleteDropdownComponentValidator()],
      viaNo: [""],
      portOfLoading: [""],
      accountHolderId: ["", Validators.required],
      chaId: ["", Validators.required],
      importerFromIgm: [""],
      importerAddressFromIgm: [""],
      consigneeId: ["", Validators.required],
      consigneeAddressId: [{ value: "", disabled: true }],
      notifyPartyId: ["", Validators.required],
      notifyPartyAddressId: [{ value: "", disabled: true }],
      boeNo: ["", Validators.required],
      boeDate: [null, Validators.required],
      smtpMovement: [false],
      smtpNo:[{ value: "", disabled: true }, Validators.required],
      numberOfPackages: ["", Validators.required],
      packageTypeId: [""],
      grossWeight: ["", Validators.required],
      grossVolume: [""],
      dpd: [false],
      hazardous: [false],
      assessableValue: ["", Validators.required],
      dutyValue: ["", Validators.required],
      goodsDescription: [""],
      commodityId: ["", Validators.required],
      examinationType: ["RMS"],
      doNo: [""],
      doDate: [null],
      doValidityDate: [null],
      deliveryModeFromDO: [null],
      highSeaSaleCustomer: [false],
      highSeaSaleCustomerId: [{ value: null, disabled: true }, [Validators.required]],
      highSeaSaleCustomerAddressId: [{ value: null, disabled: true }, [Validators.required]],
      shippingLineId: [""]
    });
  }

  goBack() {
    this.router.navigateByUrl("/manage-operations/item-filing");
  }

  autoPopulateViaNumber(event: any) {
    this.itemFilingForm.patchValue({
      viaNo: event?.viaNo
    });
  }

  async autoPopulateConsigneeAddress(selectedConsignee: any) {
    this.itemFilingForm.get("consigneeAddressId")?.enable();
    this.consigneeAddressList = await this.customerService.getCustomerContacts(selectedConsignee.id);
    const defaultContactInformation = this.consigneeAddressList?.find((contact: any) => contact.defaultContact);

    if (defaultContactInformation) {
      this.itemFilingForm.patchValue({consigneeAddressId: defaultContactInformation.id});
    }
  }

  clearConsigneeAddress() {
    this.itemFilingForm.get("consigneeAddressId")?.setValue("");
    this.itemFilingForm.get("consigneeAddressId")?.disable();
  }

  async autoPopulateNotifyParty(selectedCustomer: any) {
    this.itemFilingForm.get("notifyPartyAddressId")?.enable();
    this.notifyPartyAddressList = await this.customerService.getCustomerContacts(selectedCustomer.id);
    const defaultContactInformation = this.notifyPartyAddressList?.find((contact: any) => contact.defaultContact);

    if (defaultContactInformation) {
      this.itemFilingForm.patchValue({notifyPartyAddressId: defaultContactInformation.id});
    }
  }

  clearNotifyPartyAddress() {
    this.itemFilingForm.get("notifyPartyAddressId")?.setValue("");
    this.itemFilingForm.get("notifyPartyAddressId")?.disable();
  }

  onSmtpToggle(isActive: boolean) {
    if (this.readOnlyMode) return;
    this.itemFilingForm.get("smtpMovement")?.setValue(isActive);
    if (isActive) {
      this.itemFilingForm.get("smtpNo")?.enable();
    } else {
      this.itemFilingForm.get("smtpNo")?.setValue(null);
      this.itemFilingForm.get("smtpNo")?.disable();
    }
  }

  onDpdToggle(active: boolean) {
    this.itemFilingForm.get("dpd")?.setValue(active);
  }

  onHazardousChange(active: boolean) {
    this.itemFilingForm.get("hazardous")?.setValue(active);
  }

  onHighSealToggle(active: boolean) {
    this.itemFilingForm.get("highSeaSaleCustomer")?.setValue(active);
    this.isHighSeaSaleCustomer = active;
    this.enableControl("highSeaSaleCustomerId", active);
  }

  enableControl(controlName: string, enable: boolean) {
    if (this.readOnlyMode) return;
    if (enable) {
      this.itemFilingForm.get(controlName)?.enable();
    } else {
      this.itemFilingForm.get(controlName)?.disable();
    }
  }

  async autoPopulateHighSealCustomerAddress(selectedCustomer: any) {
    this.itemFilingForm.get("highSeaSaleCustomerAddressId")?.enable();
    this.highSealCustomerAddressList = await this.customerService.getCustomerContacts(selectedCustomer.id);
    const defaultContactInformation = this.highSealCustomerAddressList?.find((contact: any) => contact.defaultContact);

    if (defaultContactInformation) {
      this.itemFilingForm.patchValue({highSeaSaleCustomerAddressId: defaultContactInformation.id});
    }
  }

  clearHighSeaSaleCustomerAddress() {
    this.itemFilingForm.get("highSeaSaleCustomerAddressId")?.setValue("");
    this.itemFilingForm.get("highSeaSaleCustomerAddressId")?.disable();
  }

  submitForm() {
    console.log(this.tableData);

    this.itemFilingForm.markAllAsTouched();
    if (!this.itemFilingForm.valid) {
      this.scrollToFirstInvalidControl();
      console.log("Form is invalid");
      return;
    }

    this.loadingService.show();
    const cargoItem = this.getCargoItem();

    if (this.editingEnabled) {
      //update method
      // const cargoUpdateRequest = {
      //   cargoItem: { ...cargoItem },
      //   deLinkedContainerIds: Array.from(this.deLinkedContainerIds)
      // };
      this.updateItem(cargoItem);
    } else {
      this.addItem(cargoItem);
    }

  }


  scrollToFirstInvalidControl() {
    const firstInvalidControl = this.formFields.find((element) => {
      return !element.nativeElement.validity?.valid;
    });

    if (firstInvalidControl) {
      firstInvalidControl.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      // firstInvalidControl.nativeElement.focus(); // Optionally, focus the invalid element
    }
  }

  deleteRecord(selectedRows: Container[]) {
    const deletedIds = selectedRows.map((row: any) => row.id);
    const existingIds = new Set(this.tableData.map(item => item.id));
    const validIds = deletedIds.filter(id => existingIds.has(id));
    validIds.forEach(id => this.deLinkedContainerIds.add(id));
    this.tableData = this.tableData.filter(item => !validIds.includes(item.id));
  }

  private getCargoItem(): ImportCargoItem {
    this.tableData.forEach((item: any) => {
      this.tableHeaders
        .filter(header => header?.hasLookup)
        .forEach((header) => {
          const bindValue = header.fieldInfo?.lookupDetails?.responseBindValue;
          const fieldKey = header?.label;
          if (bindValue && fieldKey && item[fieldKey]) {
            const fieldData = item[fieldKey];
            if (typeof fieldData === "object") {
              item[bindValue] = item[fieldKey].key;
            } else {
              item[bindValue] = fieldData;
            }
          }
        });
    });


    const cargoItem: ImportCargoItem = {
      ...this.itemFilingForm?.value,
      portOfLoading: this.itemFilingForm?.get("portOfLoading")?.value?.key,
      accountHolderId: this.itemFilingForm?.get("accountHolderId")?.value?.key,
      vesselId: this.itemFilingForm?.get("vesselId")?.value?.key,
      chaId: this.itemFilingForm?.get("chaId")?.value?.key,
      consigneeId: this.itemFilingForm?.get("consigneeId")?.value?.key,
      notifyPartyId: this.itemFilingForm?.get("notifyPartyId")?.value?.key,
      packageTypeId: this.itemFilingForm?.get("packageTypeId")?.value?.key,
      commodityId: this.itemFilingForm?.get("commodityId")?.value?.key,
      highSeaSaleCustomerId: this.itemFilingForm?.get("highSeaSaleCustomerId")?.value?.key,
      shippingLineId: this.itemFilingForm?.get("shippingLineId")?.value?.key,
      associatedContainerList: this.tableData
    };
    console.log(cargoItem);
    return cargoItem;
  }

  private addItem(cargoItem: ImportCargoItem) {
    this.operationService.submitItemFilingForm(cargoItem).subscribe({
      next: (response: any) => {
        this.loadingService.hide();
        this.toasterService.success(
          `Item has been added successfully!`
        );
        this.loadingService.hide();
        this.goBack();
      },
      error: (error) => {
        this.toasterService.error(error.error.errorDesc);
        console.error(error);
        this.loadingService.hide();
      }
    });
  }

  private updateItem(cargoItem: any) {
    this.operationService.updateItemFilingForm(this.itemFilingId, cargoItem).subscribe({
      next: (response: any) => {
        this.loadingService.hide();
        this.toasterService.success(
          `Item has been updated successfully!`
        );
        this.loadingService.hide();
        this.goBack();
      },
      error: (error) => {
        this.toasterService.error(error.error.errorDesc);
        console.error(error);
        this.loadingService.hide();
      }
    });
  }

  initialiseCustomerAddressList(cargo: any): Observable<void> {
    this.loadingService.show();
  
    const entries = [
      ['consigneeAddressId', cargo.consigneeId, (res: any) => this.consigneeAddressList = res],
      ['notifyPartyAddressId', cargo.notifyPartyId, (res: any) => this.notifyPartyAddressList = res],
      ['highSeaSaleCustomerAddressId', cargo.highSeaSaleCustomerId, (res: any) => this.highSealCustomerAddressList = res]
    ];
  
    const requests$ = entries
      .filter(([_, id]) => id)
      .map(([controlName, id, assign]) => {
        this.enableControl(controlName, true);
        return from(this.customerService.getCustomerContacts(id)).pipe(tap(assign));
      });
  
    return requests$.length
      ? forkJoin(requests$).pipe(
          finalize(() => this.loadingService.hide()),
          map(() => undefined)
        )
      : of(undefined).pipe(finalize(() => this.loadingService.hide()));
  }


  handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const scrollThreshold = 300;
    const scrollPosition = container.scrollTop;
    const itemDetailsSectionTop = this.itemDetailsSection?.nativeElement.getBoundingClientRect().top - container.getBoundingClientRect().top;
    const containerDetailsSectionTop = this.containerDetailsSection?.nativeElement.getBoundingClientRect().top - container.getBoundingClientRect().top;

    if (scrollPosition < scrollThreshold) {
      this.selectedTab = this.tabs.ALL_SECTION;
    } else if (itemDetailsSectionTop < scrollThreshold) {
      this.selectedTab = this.tabs.ITEM_DETAILS_SECTION;
    } else if (containerDetailsSectionTop < scrollThreshold) {
      this.selectedTab = this.tabs.CONTAINER_DETAILS_SECTION;
    }

    const isScrolledToBottom = container.scrollHeight - container.scrollTop === container.clientHeight;
    if (isScrolledToBottom) {
      this.selectedTab = this.tabs.CONTAINER_DETAILS_SECTION;
    }

    this.cdRef.detectChanges();
  }

  toggleSuggestionBox(event: Event) {
    if (this.searchTerm.length > 3) {
      this.callApiToFetchSuggestions(this.searchTerm, this.searchBarSelectFields?.join(",") || "");
    } else {
      this.showSuggestions = false;
    }
  }

  callApiToFetchSuggestions(value: string, selectFields: string) {
    this.loading = true;
    this.api.searchContainers(value, selectFields).subscribe({
      next: (res: any) => {
        const fetchedSuggestions = res.data || [];
        this.suggestions = fetchedSuggestions.filter((suggestion: any) =>
          !this.tableData.some(item => item.id === suggestion.id)
        );
        this.loading = false;
        this.showSuggestions = true;
      },
      error: (err: any) => {
        console.error("Error fetching suggestions:", err);
        this.loading = false;
      }
    });
  }

  select(record: any) {
    this.searchedAndSelectedRecord = record;
    this.showSuggestions = false;
    this.searchTerm = record.containerNo;
  }

  addRecord() {
    if (!this.searchedAndSelectedRecord)
      return;

    this.tableData.push(this.searchedAndSelectedRecord);
    this.deLinkedContainerIds.delete(this.searchedAndSelectedRecord.id);
    this.searchTerm = "";
    this.searchedAndSelectedRecord = null;
  }
}
